import React from 'react';
import { WrapperItem } from '../components/wrapper-item';
import { Column } from '../components/column';
import { Section } from '../components/section';
import { Table } from '../components/table';
import { Divider } from '../components/divider';
import { shorthand } from '../utils/css-utils';
import { useWidth } from '../components/width-context';
import { GenericImage } from './generic-image';
export var SectionDivider = function (props) {
    var section = props.section, cssClass = props.cssClass, columnCssClass = props.columnCssClass;
    var backgroundColor = section.backgroundColor, borderBottom = section.borderBottom, borderLeft = section.borderLeft, borderRight = section.borderRight, borderTop = section.borderTop, dividerImageDesktop = section.dividerImageDesktop, htmlDividerStyles = section.htmlDividerStyles, dividerWidth = section.dividerWidth, dividerHeight = section.dividerHeight, outerPadding = section.outerPadding, innerPadding = section.innerPadding;
    return (React.createElement(WrapperItem, null,
        React.createElement(Section, { backgroundColor: backgroundColor, borderBottom: borderBottom, borderLeft: borderLeft, borderRight: borderRight, borderTop: borderTop, cssClass: cssClass, padding: shorthand(outerPadding) },
            React.createElement(Column, { padding: shorthand(innerPadding), cssClass: columnCssClass },
                React.createElement(RenderDivider, { htmlDividerStyles: htmlDividerStyles, dividerImageDesktop: dividerImageDesktop, dividerWidth: dividerWidth, dividerHeight: dividerHeight })))));
};
function RenderDivider(_a) {
    var htmlDividerStyles = _a.htmlDividerStyles, dividerImageDesktop = _a.dividerImageDesktop, dividerWidth = _a.dividerWidth, dividerHeight = _a.dividerHeight;
    // if we'll allow to drag dividers into the mix section, there will be issues
    // in outlook as it ignores height and images are being streched.
    var availableWidth = useWidth().width;
    if (htmlDividerStyles) {
        return (React.createElement(Table, { align: "center", width: htmlDividerStyles.width, padding: "0px" },
            React.createElement("tr", null,
                React.createElement("td", null,
                    React.createElement("div", { style: { lineHeight: '40px' } },
                        React.createElement("div", { style: {
                                display: 'inline-block',
                                width: '100%',
                                borderBottom: htmlDividerStyles.border,
                                verticalAlign: 'middle',
                            } }))))));
    }
    if (!dividerImageDesktop) {
        return React.createElement(Divider, { padding: "0px", borderColor: "#000000", borderWidth: "1px" });
    }
    return (React.createElement(GenericImage, { src: dividerImageDesktop, width: "auto", probableWidth: Math.min(dividerWidth, availableWidth), height: dividerHeight, alt: "", style: { lineHeight: '40px' }, showAfterLoad: false }));
}
//# sourceMappingURL=section-divider.js.map